import CheckBox from "components/check-box";
import Modal from "components/modal";
import ModalTemplate from "components/modal/modal-template";
import Spinner from "components/spinner";
import Typography from "components/typography";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";
import DateConvert from "utils/dateConvert";
import { IMusicData } from "types/musicData";
import SuccessModal from "components/modal/modals/successModal";
import LoadingModal from "components/modal/modals/loadingModal";
import { UploadTrack } from "./trackUpload";
import Toast from "components/toast";

interface IProps {
  finish: boolean;
  setFinish: (value: boolean) => void;
  musicData: IMusicData;
  reset: () => void;
}
const FinishModal = ({ finish, setFinish, musicData, reset }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const navigate = useNavigate();
  const [id, setId] = useState("");

  const [check, setCheck] = useState(false);

  const close = () => {
    if (!loading && uploaded) {
      navigate("/overview");
    } else if (!loading) {
      setFinish(false);
    }
  };

  const Confirm = async () => {
    try {
      setLoading(true);

      const id = await UploadTrack(musicData);

      setId(id);
      setUploaded(true);
    } catch (error) {
      Toast({ error });
    } finally {
      setLoading(false);
    }
  };

  const { coverImage, releaseTitle, stores, schedule, trackList, releaseType } =
    musicData;
  return (
    <Modal isActive={finish} closeModal={close}>
      <>
        {!loading && !uploaded && (
          <ModalTemplate
            close={close}
            header="Finish Track Release"
            confirm={Confirm}
            confirmText="Release Track"
            disableConfirm={!check}
            width="70rem"
          >
            <ModalBody>
              <SummaryDiv>
                <Typography
                  mb="1.6"
                  size="xl"
                  weight="semibold"
                  color={Colors.white100}
                >
                  Release Summary
                </Typography>
                <SummaryList>
                  <li>
                    <Typography color={Colors.grey300} weight="medium">
                      {releaseType} release, {trackList.length}{" "}
                      {trackList.length > 1 ? "tracks" : "track"}
                    </Typography>
                  </li>
                  <li>
                    <Typography color={Colors.grey300} weight="medium">
                      {stores.length} Stores
                    </Typography>
                  </li>
                  <li>
                    <Typography color={Colors.grey300} weight="medium">
                      {schedule.countries?.length} Countries
                    </Typography>
                  </li>
                  <li>
                    <Typography color={Colors.grey300} weight="medium">
                      Estimated Release Date:{" "}
                      {schedule.proposedReleaseDate
                        ? DateConvert(schedule.proposedReleaseDate)
                        : null}
                    </Typography>
                  </li>
                </SummaryList>
                <Typography color={Colors.grey500} size="s" mb="1.6">
                  After you submit we will start reviewing your release and get
                  back to you by email in the next few business days, if we find
                  something you need to fix.{" "}
                </Typography>
                <CheckItem>
                  <CheckBox
                    defaultState={check}
                    onChange={(bol) => {
                      setCheck(bol);
                    }}
                  />
                  <Typography size="s" color={Colors.grey400} ml="0.4">
                    I am completely sure i want to release this track
                  </Typography>
                </CheckItem>
              </SummaryDiv>
              <TrackDiv>
                <ImageContainer
                  src={coverImage ? URL.createObjectURL(coverImage) : ""}
                  alt="cover-image"
                />
                <Typography weight="semibold" size="xl" m_size="m">
                  {releaseTitle}
                </Typography>
              </TrackDiv>
            </ModalBody>
          </ModalTemplate>
        )}
        {loading && <LoadingModal heading="Submitting Track For Release" />}
        {!loading && uploaded && (
          <SuccessModal
            close={() => {
              navigate("/overview");
            }}
            confirm={() => {
              reset();
              setUploaded(false);
              setLoading(false);
            }}
            confirmText="Upload Another Track"
            heading="  Track Successfully Submitted"
            linkText=" Check Upload Status"
            link={`/overview/discography/track/${id}?type=${
              musicData.trackList.length > 1 ? "CONTAINER" : "SINGLE"
            }`}
          />
        )}
      </>
    </Modal>
  );
};

export default FinishModal;

const ModalBody = styled.div`
  padding: 0 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
    flex-direction: column-reverse;
  }
`;

const SummaryDiv = styled.div`
  padding-right: 3rem;
  border-right: 0.5px solid ${Colors.grey600};
  width: 50%;
  @media only screen and (max-width: 769px) {
    width: 100%;
    padding-top: 1.2rem;
    padding-right: 0;
    border-top: 0.5px solid ${Colors.grey600};
    border-right: none;
  }
`;

const SummaryList = styled.ul`
  padding: unset;
  margin: unset;
  margin-left: 1.5rem;

  li {
    margin-bottom: 1.6rem;
  }
`;

const CheckItem = styled.div`
  display: flex;
  align-items: center;
`;

const TrackDiv = styled.div`
  padding-left: 3rem;
  height: 100%;
  width: 50%;
  text-align: center;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-bottom: 1.2rem;
  }
`;

const ImageContainer = styled.img`
  width: 24.6rem;
  height: 24.6rem;
  margin-bottom: 1.6rem;
  background-color: gray;
  object-fit: cover;
  @media only screen and (max-width: 769px) {
    width: 9.6rem;
    height: 9.6rem;
    margin-bottom: 0.8rem;
  }
`;
